import { createSelector } from '@reduxjs/toolkit';

interface NamespacedStoreState {
	features: { variations: Record<string, boolean> };
}

const parseNamespace = (state: NamespacedStoreState) => state;

export const featuresSelector = createSelector(
	parseNamespace,
	state => state.features?.variations ?? {},
);
